<style scoped lang="less">
	.singleRow-module-edit{
        padding: 20px 20px 30px;
        background: #fff;
        font-size: 14px;
		
		.title{
		    position: relative;
		    font-size: 18px;
		    padding-bottom: 20px;
		    margin-bottom: 25px;
		    border-bottom: 1px solid #ddd;
		}
		
		.tip{
			font-size: 12px;
			color: #999;
			width: 370px;
			line-height: 18px;
		}
		
		.add-btn {
			text-align: center;
			border: 1px dashed #ddd;
			font-size: 16px;
			color: #666;
			height: 48px;
			line-height: 48px;
			text-align: center;
			margin-bottom: 18px;
			cursor: pointer;
			width: 100%;
			margin-top: 30px;
		}
		
    .link-info {
			width: 100%;
      height: 28px;
      line-height: 28px;
      background: #409eff;
      padding: 0 5px;
      margin-bottom: 10px;
      color: #fff;
      font-size: 14px;

      display: flex;

      .cont {
        flex: 1 1 auto;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .icon {
        flex: 0 0 auto;
      }
    }
		
	}
	
	.mod-footer{
	    margin-top: 30px;
	    padding-top: 20px;
	    border-top: 1px solid #ddd;
	
	    display: flex;
	
	    .left{
	        flex: 1 1 auto;
	        padding-top: 6px;
	    }
	}

  .blue-box{
    border: 1px solid #409EFF;
    padding: 6px 10px;
  }

    
</style>

<template>
	<!-- <transition name="scale"> -->
	<div class="singleRow-module-edit" v-if="visible">

		<p class="title">
			{{name}}
			<Icon @click="close" type="ios-close-empty" size=32 class="icon-close" color="#999"></Icon>
		</p>

    <div>
      <div class="">
        <draggable class="classify-list" :list="data.labelList" :options="{animation: 300, handle:'.link-info'}">
          <transition-group name="bounce-out-left">
            <div class="link-info" :key="item.TagId" v-for="item in data.labelList">
              <div class="cont">{{item.TagName}}</div>
              <div class="icon" @click="deleteLinkData(item)">
                <i class="el-icon-close" style="color: #fff;font-size: 16px;"></i>
              </div>
            </div>
          </transition-group>
        </draggable>
      </div>
      <div class="add-btn" @click="labelShow=true">
        <i class="el-icon-circle-plus-outline"></i>添加标签
      </div>
      <div class="flex flex-align-center">
        <div style="width:80px;text-align:right" class="margin-right-10">精选商品</div>
        <el-checkbox v-model="data.showBoutique" :label="true">显示</el-checkbox>
      </div>
      <div class="flex flex-align-center margin-top-20" v-if="data.showBoutique">
        <div style="width:80px;text-align:right" class="margin-right-10">显示标题</div>
        <el-input v-model.trim="data.title" style="width:200px" placeholder="精选" maxlength="4"></el-input>
      </div>
      <div class="flex flex-align-center margin-top-20">
        <div style="width:80px;text-align:right" class="margin-right-10">排序与筛选</div>
        <el-checkbox-group v-model="data.screen">
          <el-checkbox v-for="(v,i) in screenList" :key="i" :label="v.value">{{v.label}}</el-checkbox>
        </el-checkbox-group>
      </div>

    </div>

		<div class="mod-footer">
			<div class="left">
				<el-checkbox v-model="data.hideSpace"><span style="font-size: 14px;color:#666">隐藏模块下方的间距</span></el-checkbox>
			</div>
			<!-- <div class="right">
		            <Button type="primary" @click="saveData">保存</Button>
		        </div> -->
		</div>
		
    <choose-label :visible="labelShow" :selectedList="data.labelList" @change="changeLabel" @cancel="labelShow=false"></choose-label>
	</div>
	<!-- </transition> -->
</template>

<script>
	import config from '@/config/index'
	import {
		channelShopchannelShopInfo,
	} from "@/api/goods"
  import {
    taoKeProductlist
  } from "@/api/sv3.0.0"
	import chooseLabel from '@/views/components/chooseLabel.vue';
	import draggable from 'vuedraggable';
	export default {
		name: 'normal-module-edit',
		components: {
      chooseLabel,
      draggable
    },
		props: {
			data: {
				type: Object,
				default: () => {
					return {}
				}
			},
			visible: {
				type: Boolean,
				default: false
			},
			name: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
        labelShow:false,
        screenList:[
          // {value:0,label:'收益比例'},
          {value:1,label:'拼团价'},
        ]
			};
		},
		methods: {
      changeLabel(list){
        this.data.labelList = list;
        
      },
      deleteLinkData(e){
        this.data.labelList = this.data.labelList.filter(v => {
          return v.TagId !== e.TagId;
        })
      },
			close() {
				this.$emit('close')
			},
			
		},
		mounted() {

		},
		watch: {
			data(value) {}
		}
	};
</script>
